import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';

export default function ProjectLookup({ value }) {
  if (!value) return <div>No data</div>;

  return (
    <div className="project-lookup">
      <p className="project-lookup-code">
        {value.DateOutType
          ? value.DateOutType.Description
          : value.ProjectCode || 'No code'}
      </p>

      <p className="project-lookup-name">{value.ProjectName || ''}</p>
    </div>
  );
}
